import type { WithSuccessData } from '@maestro/core'
import type { WishlistResponseData } from '@maestro/data-layer'

import { apiGet } from '@maestro/core/api-client'

export function getWishlist({
  wishlistId,
}: {
  wishlistId?: string
}): Promise<
  WishlistResponseData & WithSuccessData<{ data: WishlistResponseData }>
> {
  return apiGet<
    WishlistResponseData & WithSuccessData<{ data: WishlistResponseData }>
  >('/api/wishlist', { wishlistId })
}
